const setScrollPadding = () =>{
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const header = document.querySelector('.ume-fixed');
    if(header !== null){
        let headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        if(document.querySelector('.ume-anchor-holder')){
            headerHeight = headerHeight + document.querySelector('.ume-anchor-holder').offsetHeight + 20;
        }
        document.documentElement.style.setProperty('--scroll-padding-height', headerHeight + 'px');
    }

}
export default setScrollPadding;

document.addEventListener('recalculateScrollPadding', ev =>{
    setScrollPadding();
})